import { createContext, useContext } from 'react';

export const SiteSettingsContext = createContext({
  blogEnabled: true,
});

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
